import { request } from '../../helpers/api/request';

export const getAllFilters = async () => {
    const { data } = await request({
        url: 'filters',
    });

    return data;
};
